import React from 'react';
import LeaderboardTableRecord from './LeaderboardTableRecord';

export interface ILeaderboardTableProps {
  stringHeader: string;
  numberHeader: string;
  data: Array<[string, number]>;
}

const LeaderboardTable: React.FC<ILeaderboardTableProps> = (props: ILeaderboardTableProps) => {
    let rows = [];
    for (let i = 0; i < props.data.length; ++i) {
        let className: string = (i % 2 === 0 ? "LeaderboardTableEvenRow" : "LeaderboardTableOddRow");

        if (i === 0) {
            className = "LeaderboardTableFirstPlaceRow";
        }
        else if (i === 1) {
          className = "LeaderboardTableSecondPlaceRow";
        }
        else if (i === 2) {
          className = "LeaderboardTableThirdPlaceRow";
        }

        rows.push(
            <LeaderboardTableRecord
                index={(i+1).toString()}
                stringValue={props.data[i][0]}
                numberValue={props.data[i][1].toString()}
                className={className} />
        );
    }
    return (
      <table className="LeaderboardTable">
        <LeaderboardTableRecord
            index=""
            stringValue={props.stringHeader}
            numberValue={props.numberHeader}
            className="LeaderboardTableHeaderRow" />
        {rows}
      </table>
    );
  }
  
  export default LeaderboardTable;